import { Business } from "@mui/icons-material";
import OrganisationResponse from "../../models/Organisation";
import { OpenInNewTabButton } from "../OpenInNewTabButton";
import { BadgeProps, BaseBadge } from "./BaseBadge";
import { useContext } from "react";
import { AbilityContext } from "../../feature/UserApi/logic/Can";
import { PermissionEnum } from "../../feature/Permission/PermissionEnum";

export function OrganisationBadge(props: BadgeProps<OrganisationResponse>) {
    const ability = useContext(AbilityContext);
    const canReadOrg = ability.can(PermissionEnum.ORGANISATION_READ, props.ressource);
    const noLink = props.noLink || !canReadOrg;

    if (props.textOverride)
        return <BaseBadge {...props} content={<>{props.textOverride}</>} icon={Business} />

    const content = props?.ressource?.name
    const icon = <BaseBadge deepContent={!noLink} {...props} content={<>{content}</>} icon={Business} />
    return noLink ? icon : <OpenInNewTabButton url={`/organisations/${props?.ressource?.uuid}`} icon={icon} padding={0} />
}